import React from 'react';
import OtpInput from 'react-otp-input';

interface Props {
  otp: string;
  handleChange: (otp: string) => void;
  numInputs: number;
}

const OtpInputs = ({ otp, handleChange, numInputs }: Props) => {
  return (
    <OtpInput
      value={otp}
      onChange={handleChange}
      numInputs={numInputs}
      separator={<span>&nbsp;</span>}
      isInputNum={true}
      inputStyle={{
        width: '48px',
        height: '48px',
        borderRadius: '4px !important',
        background: '#F4F4F5',
        borderBottom: 'none !important',
        borderBottomWidth: '0px !important',
        caretColor: '#1572ED',
        border: '1px solid transparent',
      }}
      focusStyle={{
        border: '1px solid #1572ED',
        outline: 'none',
      }}
      shouldAutoFocus={true}
    />
  );
};

export default OtpInputs;



// WEBPACK FOOTER //
// ./components/common/otpInputs.tsx